import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { getProduct } from "@/lib/products";
import AgenteTracaoComercial from "@/pages/AgenteTracaoComercial";

export const Route = createFileRoute("/agente-tracao-comercial")({
  head: () => buildHead({
    title: `${getProduct("agente-tracao-comercial")!.name} — OP2P CRM e Agentes de IA`,
    description: `${getProduct("agente-tracao-comercial")!.tagline} ${getProduct("agente-tracao-comercial")!.description}`,
    path: "/agente-tracao-comercial",
  }),
  component: AgenteTracaoComercial,
});
